import React from "react";
import Quote from "./quote.js";
import "../../styles/footer.css";
import "../../styles/header.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="horizontal-line" />
      <div className="footer-container">
      <div className="footer-socials">
          <p>Social Profiles</p>
          <ul>
            <li><a href="https://www.linkedin.com/in/ioonicu/" target="_blank" rel="noreferrer">LinkedIn</a></li>
          </ul>
        </div>
        <Quote />
        <div className="copyright">
          <span style={{ fontSize: "12px"}}>©</span><p> {" "} {year} Ion NICULICA</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer;